import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy'
import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons/faArrowRotateLeft'

import { IEvaluationResume } from 'models/evaluation.model'
import { Wrapper } from './styled'

interface IProps {
  evaluation: IEvaluationResume
}

const SimpleResume = ({ evaluation }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluationBlock.detail'

  return (
    <Wrapper>
      <div>
        <FontAwesomeIcon icon={faList} />
        <span>{evaluation.totalQuestions}</span>
        <div>{t(`${translationPrefix}.totalQuestions`)}</div>
      </div>
      <div>
        <FontAwesomeIcon icon={faTrophy} />
        <span>{evaluation.minimumPassingScore}</span>
        <div>{t(`${translationPrefix}.minimumPassingScore`)}</div>
      </div>
      {evaluation.multipleRetries && (
        <div>
          <FontAwesomeIcon icon={faArrowRotateLeft} />
          <span>{evaluation.maxRetries}</span>
          <div>{t(`${translationPrefix}.attemptsAllowed`)}</div>
        </div>
      )}
      {!evaluation.multipleRetries && (
        <div>
          <FontAwesomeIcon icon={faArrowRotateLeft} />
          <span>{t(`${translationPrefix}.unlimitedAttempts`)}</span>
          <div>{t(`${translationPrefix}.attemptsAllowed`)}</div>
        </div>
      )}
    </Wrapper>
  )
}

export default SimpleResume
